import {
	WideViewOwnershipTableItemData,
	useWideViewOwnershipTableController,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Ownership/WideViewOwnershipTable/useWideViewOwnershipTableController';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { MantineTable } from '@dealstack/frontend/shared/components/Table/MantineTable/MantineTable';
import { rem } from '@mantine/core';
import styled from 'styled-components';
import { HoldingRes } from '@dealstack/shared/lib/generated';
import { HoldingCustomSettings } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Holdings/HoldingCustomSettings.tsx';
import {
	GENERIC_ELEMENT_ID,
	makeComplexDataTestId,
} from '@dealstack/shared/tests/testElementIds.ts';

interface Props {
	showSummarized: boolean;
	showPercentages: boolean;
	isLoading: boolean;
	isOwnership: HoldingRes[];
	downloadCSV: () => void;
}

const WideViewOwnershipTable = ({
	showSummarized,
	showPercentages,
	isLoading,
	isOwnership,
}: Props) => {
	const { columns, wideViewOwnershipData, mantineTableDataOperations, isSecuritiesLoading } =
		useWideViewOwnershipTableController({
			showSummarized,
			showPercentages,
			isOwnership,
		});

	return (
		<MantineTable<WideViewOwnershipTableItemData>
			columns={columns}
			data={wideViewOwnershipData}
			isLoading={isLoading || isSecuritiesLoading}
			dataOperations={mantineTableDataOperations}
			enableRowSelection={false}
			enableRowActions={false}
			manualFiltering={false}
			manualPagination={false}
			manualSorting={false}
			enableStickyHeader={true}
			enableColumnResizing={true}
			pinnedColumnIds={['holder']}
			enableExpanding={true}
			grouped={true}
			getSubRows={(row) => row.subRows as unknown as WideViewOwnershipTableItemData[]}
			icons={{ IconChevronDown: () => <Icon variant="chevron-down" size="md" /> }}
			renderBulkActionsMenu={false}
			customSettingsRenderer={(table) => (
				<HoldingCustomSettings<WideViewOwnershipTableItemData> table={table} />
			)}
			mantineTableBodyRowProps={({ row }) => ({
				id: row.id,
				'data-testid': makeComplexDataTestId(
					GENERIC_ELEMENT_ID.MANTINE_TABLE_ROW,
					row.original.holderName ?? ''
				),
			})}
		/>
	);
};

const Styled = styled(WideViewOwnershipTable)`
	--mantineTableHeaderHeight: ${rem(40)};
	height: 100%;

	thead {
		tr:first-of-type input {
			display: none;
		}
		tr:nth-child(1) {
			top: 0;
			z-index: 1;
		}
		tr:nth-child(2) {
			top: var(--mantineTableHeaderHeight);
		}
	}
`;

export { Styled as WideViewOwnershipTable };
